import { HandballIncidentId } from '@collector/sportsapi-client-legacy'
import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

export const SuspensionOverPopup = new PopupBuilder('SuspensionOver', {
  incident_id: HandballIncidentId.SuspensionOver,
})
  .withTeamSelection()
  .omitDetailsView()
  .build()
